<template>
  <div>
    <div class="search">
      <input v-on:keyup.13="search" v-model="keyword" type="text" :placeholder="placeholder" @input="input()"/>
      <div class="searchList" v-if="showSearchList">
        <ul>
          <li v-for="item in searchList" v-if="showBusiness" @click="getGoods(item)">{{item.name + '——' +item.website}}</li>
          <!-- <li v-for="item in searchList" v-if="showGoods" @click="getGoodDetail(item)">{{item.name}}</li>
          <li @click="searchInSephora()" v-if="keyword">在丝芙兰中搜索商品</li>
          <li @click="searchInCurrency('Nordstrom')" v-if="keyword">在Nordstrom中搜索商品</li>
          <li @click="searchInCurrency('JoyOrders')" v-if="keyword">在Joyorders自营店中搜索商品</li> -->
        </ul>
      </div>
       <!-- <el-autocomplete
        class="inline-input input"
        v-model="keyword"
        :fetch-suggestions="querySearch"
        :placeholder="placeholder"
        :trigger-on-focus="false"
        @select="handleSelect"
      >
      <template slot-scope="{ item }">
        <div class="name">{{ item.value }}</div>
      </template>
      </el-autocomplete> -->
      <i class="el-icon-search lighter-gray-txt" @click="search()"></i>
    </div>
  </div>
</template>

<script>
import api from '../services/api';
let _ = require('lodash')
export default {
  name: 'HelloWorld',
  props: ['placeholder', 'object', 'objectKey'],
  data () {
    return {
      keyword: '',
      searchList: null,
      showSearchList: false,
      showBusiness: true,
      showGoods: false
    }
  },
  mounted(){
        document.body.addEventListener('click',()=>{
            this.showSearchList = false;
        },false);
    },
  methods: {
    input () {
      this.search()
    },
    async search () {
      let parmas = {
        name: this.keyword
      }
        let res = await api.serchBusinessList(this,parmas)
        if(res.body.status == 'ok'){
          if(res.body.result){
            this.searchList = res.body.result
            this.showBusiness = true
            this.showGoods = false
            this.showSearchList = true
          }else{
            let good = await api.serchGoodsList(this,parmas)
            if(good.body.result.length >0) {
              if(good.body.result.length > 1) {
                this.searchList = good.body.result
                this.showGoods = true
                this.showBusiness = false
                this.showSearchList = true
              }else{
                this.$router.push({name:'Item',params:{id:good.body.result[0].id}})
              }
            }
          }
            console.log(this.searchList)
        }

    },
    searchInSephora () {
      localStorage.setItem('SearchKeyword',this.keyword)
      this.$router.push({name:'Goods',params:{id:'SephoraUS'}})
    },
    searchInCurrency (id) {
      localStorage.setItem('SearchKeyword',this.keyword)
      this.$router.push({name:'NormalProduct',params:{id:id}})
    },
    getGoods (item) {
        this.$router.push({name: 'Merchant', params: {id: item.tag}})
    },
    getGoodDetail(item) {
        this.$router.push({name:'Item',params:{id:item.id}})
    }
    // async querySearch(queryString, cb) {
    //   let searchList = []
    //   let parmas = {
    //     name: queryString
    //   }
    //     let res = await api.serchBusinessList(this,parmas)
    //     if(res.body.result){
    //       _.each(res.body.result,item => {
    //         let business = {
    //           value: item.name + '——' + item.website,
    //           leble: item.id,
    //           type: 'business'
    //         }
    //         searchList.push(business)
    //       })
    //       console.log(searchList)
    //       searchList.push({value:'在丝芙兰中搜索',type:'goodSearch'})
    //     }else{
    //       let good = await api.serchGoodsList(this,parmas)
    //       if(good.body.result) {
    //         if(good.body.result.length > 1) {
    //           _.each(good.body.result,item => {
    //             let good = {
    //                value: item.name,
    //                leble: item.id,
    //                type: 'good'
    //             }
    //             searchList.push(good)
    //           })

    //         }
    //       }

    //     }
    //       cb(searchList);

    // },
    // handleSelect (item) {
    //   if(item.type == 'business') {
    //     this.$router.push({name: 'Goods', params: {id: item.leble}})
    //   }
    //   if(item.type == 'goodSearch') {
    //     this.isGoodSearch = true
    //   }
    // }
  },
  watch: {
    showSearchList (val){
      this.$emit('search',val)
    }
  },
}
</script>

<style scoped lang="scss">
.search {
  position: relative;

  input {
    display: block;
    width:100%;
    height: 38px;
    border: 1px solid #d7d7d7;
    line-height: 18px;
    padding: 10px;
    background: #f3f3f9;
    padding-right: 45px;
  }
  .input  {
    width: 100%;
  }
  .el-icon-search {
    font-size: 24px;
    top: 8px;
    right: 15px;
    position: absolute;
  }

  .searchList {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #fff;
    max-height: 200px;
    overflow-y: scroll;

    &::-webkit-scrollbar {/*滚动条整体样式*/
        width: 0px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
    }
    &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 10px;
        background: rgba(144,147,153,.3);
    }
    &::-webkit-scrollbar-track {/*滚动条里面轨道*/
        border-radius: 10px;
    }
    li {
      font-size: 14px;
      padding: 0 20px;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #606266;
      height: 34px;
      line-height: 34px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      cursor: pointer;
      &+li {
        border-top: 1px solid #cdcdcd;
      }
      &:hover {
        color: #ffffff !important;
        background: #333333;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchIpt.vue